/**
 * Bounds of the "Membri dello staff" field of the venue onboarding.
 *
 * The count is split in half into `staff_size_floor` and `staff_size_kitchen`, which the
 * backend accepts only as integers from 0 to 2,147,483,646 (`Restaurant.changeset`): a
 * negative or huge count used to reach `POST /organizations` and come back as a 422 the
 * employer could not decode. The 500 ceiling is ours: measured on 07/10/2026 over 6,713
 * venues, the largest has 300 and 99% have 40 or fewer, so a higher number is almost always a
 * typo (a phone number, an extra zero).
 */
export const MAX_STAFF_MEMBERS = 500;

/** Translation function shape (a subset of next-i18next's `t`). */
type TFunc = (key: string, options?: Record<string, unknown>) => string;

/**
 * `true` when the staff count is acceptable, otherwise the message to show under the field.
 * An empty value is accepted: the field is optional.
 */
export function validateStaffCount(value: unknown, t: TFunc): true | string {
  const text = value === null || value === undefined ? '' : String(value).trim();
  if (text === '') return true;
  if (!/^\d+$/.test(text) || Number(text) > MAX_STAFF_MEMBERS)
    return t('staff_members_invalid', { max: MAX_STAFF_MEMBERS });
  return true;
}
